import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import { SCREEN_CONTEXT_OMITTED_KEY } from './situationalAwarenessKeys';

// These describe the screen rather than the user, and a stored payload outlives
// the route it came from - a card surface unmounts with no later route change to
// correct it - so they are dropped when replayed onto a different route.
var ROUTE_SCOPED_KEYS = ['screenContext', SCREEN_CONTEXT_OMITTED_KEY, 'searchQuery'];

// Shared by every agent surface, safely even with several mounted at once (the
// dock is hidden rather than unmounted): containerId is not part of the payload,
// so they all build an identical object.
var lastFullContext = {};
var lastFullContextRoute = null;
export function setLastFullContext(context) {
  var _context$currentRoute;
  lastFullContext = context;
  lastFullContextRoute = (_context$currentRoute = context.currentRoute) !== null && _context$currentRoute !== void 0 ? _context$currentRoute : null;
}
export function getLastFullContext(currentRoute) {
  if (lastFullContextRoute === currentRoute) return lastFullContext;
  return Object.fromEntries(Object.entries(lastFullContext).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !ROUTE_SCOPED_KEYS.includes(key);
  }));
}